export default "__VITE_ASSET__YpNCgUOv__"